import React from 'react';
import { Field, reduxForm } from 'redux-form';

import SingleColumn from '$ContainersLegacy/SingleColumn';
import TextFieldCSS from '$Fields/TextField/TextField-css';
import { IntlMessage } from '$HVUI';
import Button from '$Molecules/Buttons/Button';
import FormButton from '$Molecules/Buttons/FormButton';
import { notEmpty } from '$Validation/i18n-validator';

export class LoginForm extends React.Component {
    render() {
        const { handleSubmit, invalid, submitting } = this.props;
        return (
            <SingleColumn marginTop={48} marginBottom={72}>
                <form
                    onSubmit={handleSubmit}
                    className="login-form-wrapper"
                    data-complete={!invalid && !submitting}
                >
                    <Field
                        name="username"
                        component={TextFieldCSS}
                        data={{
                            label: (
                                <IntlMessage
                                    id="sign-in.email-address-or-username"
                                    defaultMessage="Email Address or Username"
                                />
                            )
                        }}
                        validate={[notEmpty]}
                    />
                    <Field
                        name="password"
                        component={TextFieldCSS}
                        data={{
                            label: (
                                <IntlMessage
                                    id="sign-in.password"
                                    defaultMessage="Password"
                                />
                            )
                        }}
                        type="password"
                        validate={[notEmpty]}
                    />
                    <FormButton
                        center
                        element="button"
                        text={
                            <IntlMessage
                                id="all.submit"
                                defaultMessage="Submit"
                            />
                        }
                        {...this.props}
                    />
                </form>
                <div style={{ margin: '2em 0 1em 0' }}>
                    <Button
                        style={{ color: 'var(--red100)' }}
                        kind="secondary"
                        text={
                            <IntlMessage
                                id="sign-in.forgot-password"
                                defaultMessage="Forgot Password?"
                            />
                        }
                        element="Link4"
                        to="/forgot-password"
                    />
                </div>
            </SingleColumn>
        );
    }
}

export default reduxForm({
    form: 'LoginForm'
})(LoginForm);
